import React from 'react';
import { Button, Divider } from 'antd';
import { useTranslate } from '@tolgee/react';

type Props = {
  isDeclineMode: boolean;
  canSubmit: boolean;
  isSubmitting: boolean;
  itemCount: number;
  onSubmit: () => void;
  onToggleDecline: () => void;
};

const AbandonedBusinessActions: React.FC<Props> = ({
  isDeclineMode,
  canSubmit,
  isSubmitting,
  itemCount,
  onSubmit,
  onToggleDecline,
}) => {
  const { t } = useTranslate();

  return (
    <div style={{ marginTop: 32 }}>
      <Button
        type='primary'
        size='large'
        block
        disabled={!canSubmit}
        loading={isSubmitting}
        onClick={onSubmit}
        style={{
          height: 52,
          borderRadius: 14,
          fontWeight: 600,
          fontSize: 16,
          background: canSubmit ? '#8dbc9a' : undefined,
          borderColor: canSubmit ? '#8dbc9a' : undefined,
        }}
      >
        {isDeclineMode ? (
          t('Send')
        ) : (
          <>
            {t('Confirm Selection')}
            {itemCount > 0 && <span style={{ opacity: 0.85 }}> · {itemCount}</span>}
          </>
        )}
      </Button>
      <Divider style={{ margin: '16px 0', color: '#8c9aa5', fontSize: 12 }}>
        {t('or')}
      </Divider>
      <Button
        type='text'
        block
        onClick={onToggleDecline}
        style={{
          color: '#4a7df5',
          fontWeight: 500,
          fontSize: 14,
          height: 44,
        }}
      >
        {isDeclineMode ? t('Back to dishes') : t('Contact Us')}
      </Button>
    </div>
  );
};

export default AbandonedBusinessActions;

